import { FC, useRef, useEffect } from 'react'

import SelectDropdown from '~/src/components/generic/SelectDropdown'

import useTranslation from '~/src/hooks/useTranslation'

import { tw } from '~/lib/utils'

import { Option } from '~/src/components/ReportIssue/types'

type Props = {
  options: Array<Option>
  selectedOption: Option
  isError: boolean
  isV2?: boolean
  validationError: string
  onOptionChange: (value: Option) => void
  onDetailsChanged: (value: string) => void
  onSubjectChanged: (value: string) => void
}

const CreateTaskStep: FC<Props> = ({
  options,
  selectedOption,
  isError,
  isV2,
  validationError,
  onOptionChange,
  onDetailsChanged,
  onSubjectChanged,
}) => {
  const { t } = useTranslation('common')
  const subjectRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (subjectRef.current) {
      subjectRef.current.focus()
    }
  }, [])

  return (
    <div className="space-y-4">
      {!isV2 && (
        <div className="flex flex-col space-y-1">
          <div className="font-medium">{t('reportIssue.typeOfFeedback')}</div>
          <SelectDropdown
            className="text-body-s"
            options={options}
            selectedOption={selectedOption}
            onOptionChange={onOptionChange}
          />
        </div>
      )}

      <div className="flex flex-col space-y-1 text-body-m">
        <label className="font-medium" htmlFor="subject">
          {t('reportIssue.subject')}
        </label>
        <input
          className={tw(
            'h-10 appearance-none rounded-md border border-input p-2 text-body-m focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-body-m sm:font-light',
            validationError ? 'border-critical' : ''
          )}
          id="subject"
          placeholder={t('reportIssue.subjectPlaceholder')}
          ref={subjectRef}
          type="text"
          onChange={(event) => onSubjectChanged(event.target.value)}
        />
        <div className="text-body-s text-critical">{validationError}</div>
      </div>

      <div className="flex flex-col space-y-1 text-body-m">
        <label className="font-medium" htmlFor="details">
          {t('reportIssue.details')}
        </label>
        <textarea
          className="h-40 w-full resize-none appearance-none rounded-md border border-input p-2 text-body-m focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-body-m sm:font-light"
          id="details"
          placeholder={t('reportIssue.detailsPlaceholder')}
          onChange={(event) => onDetailsChanged(event.target.value)}
        ></textarea>
      </div>

      {isError && (
        <div className="text-critical">{t('reportIssue.somethingWentWrong')}</div>
      )}
    </div>
  )
}

export default CreateTaskStep
